module.exports = {"PayRaja":"PayRaja","Earn Money as a UPI Agent":"Earn Money as a UPI Agent","Download APK":"Download APK","Become a UPI Payment Agent & Start Earning!":"Become a UPI Payment Agent & Start Earning!","Order Amount":"Order Amount","Bonus":"Bonus","You Can Earn":"You Can Earn","Download to Earn Money Now":"Download to Earn Money Now","HELP":"HELP"}


//////////////////
// WEBPACK FOOTER
// ./src/locales/en.json
// module id = NuBg
// module chunks = 2